import React from 'react';

import { Spinner, SvgIcon } from '.';
import { styled } from '../theme';

type OwnProps = {
    isSelected?: boolean;
    isSaving?: boolean;
    disabled?: boolean;
    customIcon?: React.ReactNode;
};
type Props = OwnProps & React.HTMLProps<HTMLDivElement>;

const StyledListItem = styled('div')<Props>(({ theme, isSelected, isSaving, disabled }) => ({
    flex: 1,
    cursor: disabled ? 'default' : 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    minHeight: 50,
    paddingLeft: 20,
    paddingRight: 20,
    borderRadius: theme.borderRadius.base,
    background: theme.color.white,
    ':hover': {
        background: '#e9eaea',
    },
    ...(isSelected && {
        color: theme.color.green1,
    }),
    ...(isSaving && {
        color: theme.color.gray40,
        cursor: 'default',
        ':hover': { backgroud: theme.color.white },
        ':active': { backgroud: theme.color.white },
    }),
    ...(disabled && {
        color: theme.color.gray40,
    }),
}));

const ListItem = React.forwardRef<HTMLDivElement, Props>(
    ({ isSelected, isSaving, disabled, customIcon, ...props }, ref) => {
        const isIndicatorShown = Boolean(isSaving || isSelected || customIcon);

        return (
            <StyledListItem
                ref={ref}
                isSelected={isSelected}
                isSaving={isSaving}
                disabled={disabled}
                {...props}
            >
                {props.children}
                {isIndicatorShown && (
                    <div>
                        {isSaving && <Spinner />}
                        {isSelected && (
                            <SvgIcon
                                src="/icons/ic-status-success.svg"
                                color={(theme) => theme.color.success}
                                style={{}}
                            />
                        )}
                        {customIcon && customIcon}
                    </div>
                )}
            </StyledListItem>
        );
    }
);

export default ListItem;
